// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8gLl_","placeholdersHeader":"styles_placeholdersHeader__R9nZ3","editorStyle":"styles_editorStyle__3ExOa","placeholdersBox":"styles_placeholdersBox__16KVR"};